import { Heart, Clock } from "lucide-react";

export function FavoritesSection({ favoriteExercises, exercises, onSelectExercise }) {
  if (favoriteExercises.length === 0) return null;
  return (
    <div data-testid="favorites-collection" className="mb-8">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-sm font-bold text-gray-700 flex items-center gap-2">
          <Heart className="w-4 h-4 text-red-500 fill-red-500" />
          My Favorites
          <span className="text-xs font-medium text-gray-400">({favoriteExercises.length})</span>
        </h2>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
        {favoriteExercises.map((fav) => {
          const fullExercise = exercises.find(e => e.id === fav.item_id);
          return (
            <div
              key={fav.id}
              data-testid={`favorite-card-${fav.item_id}`}
              onClick={() => fullExercise && onSelectExercise(fullExercise)}
              className="flex-shrink-0 w-56 rounded-xl bg-white border border-red-100 hover:border-red-300 hover:shadow-lg hover:shadow-red-500/5 transition-all duration-200 cursor-pointer group p-3"
            >
              <div className="flex items-start justify-between gap-2 mb-1.5">
                <h3 className="text-xs font-bold text-gray-900 group-hover:text-emerald-700 transition-colors line-clamp-2 leading-tight">
                  {fav.item_title}
                </h3>
                <Heart className="w-3 h-3 text-red-400 fill-red-400 flex-shrink-0 mt-0.5" />
              </div>
              <div className="flex items-center gap-2 text-[10px] text-gray-400">
                {fav.item_data?.duration_minutes && (
                  <span className="flex items-center gap-0.5">
                    <Clock className="w-2.5 h-2.5" />
                    {fav.item_data.duration_minutes}m
                  </span>
                )}
                {fav.item_data?.difficulty && (
                  <span className={`px-1.5 py-0.5 rounded-full font-semibold ${
                    fav.item_data.difficulty === 'beginner' ? 'bg-green-50 text-green-600' :
                    fav.item_data.difficulty === 'intermediate' ? 'bg-amber-50 text-amber-600' :
                    'bg-red-50 text-red-600'
                  }`}>
                    {fav.item_data.difficulty}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
